const validate = require('@weo-edu/validate')
const Schema = require('@weo-edu/schema')

const updateTimestamp = Schema()

exports.updateTimestamp = validate(updateTimestamp)
